import {isDev, isLocal} from './helpers';

const local = {
    loginURL: 'https://zeto-deploymentdev.auth.eu-central-1.amazoncognito.com/login?client_id=58sdv2iptbug5hkl6ol10d2l6n&response_type=code&scope=email+openid&redirect_uri=http://localhost:8086',
    initData: {
        client_id: '58sdv2iptbug5hkl6ol10d2l6n',
        grant_type: 'authorization_code',
        redirect_uri: 'http://localhost:8086'
    }
};
const dev = {
    loginURL: 'https://zeto-deploymentdev.auth.eu-central-1.amazoncognito.com/login?client_id=58sdv2iptbug5hkl6ol10d2l6n&response_type=code&scope=email+openid&redirect_uri=https://deploymentdev.zetoserver.com',
    initData: {
        client_id: '58sdv2iptbug5hkl6ol10d2l6n',
        grant_type: 'authorization_code',
        redirect_uri: 'https://deploymentdev.zetoserver.com'
    }
};
const prod = {
    loginURL: 'https://zeto-deployment.auth.eu-central-1.amazoncognito.com/login?client_id=m94t4eqg55d92n0opaop7uc1f&response_type=code&scope=email+openid&redirect_uri=https://deployment.zetoserver.com',
    initData: {
        client_id: 'm94t4eqg55d92n0opaop7uc1f',
        grant_type: 'authorization_code',
        redirect_uri: 'https://deployment.zetoserver.com'
    }
};
const config = isLocal() ? local : isDev() ? dev : prod;
export default config;